module.exports = __webpack_public_path__ + "media/images/sale-ai_graph1_2-542ed47b.png";